import { ApplicationConfig, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { environment } from '@envs/environment';
import { authInterceptor } from 'app/shared/interceptors/auth.interceptor';
import { retryInterceptor } from 'app/shared/interceptors/retry.interceptor';

import { GlobalStore } from 'app/shared/store/global.store';
import player from 'lottie-web';
import { provideLottieOptions } from 'ngx-lottie';
import { provideMarkdown } from 'ngx-markdown';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { routes } from './app.routes';
import { stompRxServiceFactory, StompService } from './shared/services/stomp.service';
import { DialogService } from 'primeng/dynamicdialog';

export const appConfig: ApplicationConfig | any = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAppInitializer(() => {
      const globalStore = inject(GlobalStore);
      globalStore.loadConfiguration();
    }),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(
      withInterceptors([authInterceptor, retryInterceptor])
    ),
    providePrimeNG({
      ripple: true,
      theme: {
        preset: environment.theme.preset,
        options: {
          darkModeSelector: environment.theme.themeClass,
          cssLayer: {
            name: 'primeng',
            order: 'inpla-styles, reset, primeng',
          },
        },
      },
    }),
    MessageService,
    DialogService,
    provideMarkdown(),
    provideLottieOptions({
      player: () => player,
    }),
    {
      provide: StompService,
      useFactory: stompRxServiceFactory,
    },
  ],
};
